import i18n from 'i18next';

export function getLocationLocale() {
  return (i18n.resolvedLanguage || i18n.language)?.startsWith('es')
    ? 'es'
    : 'pt-BR';
}

export function formatLocationRelativeTime(
  timestamp: string | null | undefined,
  now = Date.now(),
  recentThresholdSeconds = 10,
): string | null {
  if (!timestamp) return null;
  const value = new Date(timestamp).getTime();
  if (!Number.isFinite(value)) return null;

  const seconds = Math.max(0, Math.floor((now - value) / 1000));
  if (seconds < recentThresholdSeconds) return i18n.t('locationTransport.now');

  const formatter = new Intl.RelativeTimeFormat(getLocationLocale(), {
    numeric: 'always',
  });
  if (seconds < 60) return formatter.format(-seconds, 'second');
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return formatter.format(-minutes, 'minute');
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return formatter.format(-hours, 'hour');
  return formatter.format(-Math.floor(hours / 24), 'day');
}
